import { useMemo } from 'react';
import { I18n } from '~/common/explicit-exports';

export function useRelativeTimeFormatter(options?: Intl.RelativeTimeFormatOptions) {
  const locale = I18n.currentLocale().replace(/_/g, '-');
  return useMemo(() => new Intl.RelativeTimeFormat(locale, options), [locale, options]);
}
